import { useDatepickerRangeStore } from '@/stores/DatepickerRangeStore/DatepickerRangeStore';
import { DatepickerGrid } from './DatepickerGrid';
import { DatepickerType } from '../../Datepicker.consts';

export const DatepickerRangeGrid: React.FC = () => {
  const { year, month } = useDatepickerRangeStore();

  return <DatepickerGrid month={month} year={year} type={DatepickerType.RANGE} />;
};
